import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/AuthApi/';
export const sysLogin = (data)=>{
  return getInterface.post(`${prefixUrl}sysLogin`, data);
}
export const loginOut = (data)=>{
  return getInterface.post(`${prefixUrl}loginOut`, data);
}
